import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, firstValueFrom, Subject } from 'rxjs';
import { Catalog } from 'src/app/common/enumerations/enumerations';
import { AcceleratorCatalog, AcceleratorHistory } from 'src/app/components/catalogs/accelerator-catalog/services/accelerator-catalog';
import { BeamlineCatalog, BeamlineHistory, ResourceSummary } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { Move } from 'src/app/components/catalogs/catalog-model';
import { CatalogService } from 'src/app/components/catalogs/catalog-service';
import { PendingAccelerator, PendingResource } from 'src/app/services/pending-approvals/pending-approval';

@Component({
  selector: 'catalog-history-navigation',
  templateUrl: './catalog-history-navigation.component.html',
  styleUrls: ['./catalog-history-navigation.component.scss']
})
export class CatalogHistoryNavigationComponent implements OnChanges {

  @Input() type?: Catalog;
  @Input() historyIDs?: number[];
  @Output() selectedAcceleratorHistory = new EventEmitter<AcceleratorCatalog>();
  @Output() selectedBeamlineHistory = new EventEmitter<BeamlineCatalog>();

  catalog?: AcceleratorCatalog | BeamlineCatalog;
  catalogInfo?: PendingAccelerator | PendingResource | null;

  historyData?: AcceleratorHistory[] | BeamlineHistory[] = [];
  index: number = 0;

  move = Move;
  sliderCtrl!: FormControl;

  private indexSubject = new Subject<number>();

  constructor(
    private _service: CatalogService
  ) {

  }

  ngOnInit() {
    this.indexSubject.pipe(debounceTime(1500)).subscribe((index) => {
      this.index = index;
      this.selectedIndex();
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.historyIDs?.length) {
      this.historyIDs.sort((a, b) => a - b);
      this.index = this.historyIDs.length - 1;
      if (!this.historyData?.length) this.loadHistoryData();
      this.sliderCtrl = new FormControl(this.index);
      this.selectedIndex();
    }
  }

  loadHistoryData() {
    this.historyData = this.historyIDs?.map(i => {
      switch (this.type) {
        case Catalog.AcceleratorCatalog:
          return { id: i } as AcceleratorHistory;
        case Catalog.BeamlineCatalog:
          return { id: i } as BeamlineHistory;
        default:
          return {} as any;
      }
    });
  }

  moveOnHistory(move: Move) {
    switch (move) {
      case Move.FIRST:
        this.index = 0;
        break;
      case Move.LAST:
        this.index = (this.historyData?.length ?? 1) - 1;
        break;
      default:
        this.index += move;
    }

    if (this.index < 0) this.index = 0;
    if (this.index > (this.historyData?.length ?? 1) - 1) this.index = (this.historyData?.length ?? 1) - 1;
    this.selectedIndex();
  }

  changed(e: any) {
    const value = e;
    this.indexSubject.next(value);
  }



  async selectedIndex() {
    const historyItem: any = this.historyData?.[this.index];

    switch (this.type) {
      case Catalog.AcceleratorCatalog:
        let acceleratorCatalog = historyItem?.acceleratorCatalog;
        if (acceleratorCatalog)
          this.catalog = acceleratorCatalog;
        else {
          acceleratorCatalog = (await this.getPendingCatalog(historyItem.id)).acceleratorCatalogs?.at(-1) as AcceleratorCatalog;
          historyItem.acceleratorCatalog = acceleratorCatalog;
        }
        this.catalog = acceleratorCatalog as AcceleratorCatalog;

        this.catalogInfo = (this.catalog as AcceleratorCatalog).pendingAcceleratorCatalog;
        this.selectedAcceleratorHistory.emit(this.catalog);
        break;

      case Catalog.BeamlineCatalog:
        // this.catalog = historyItem?.beamlineCatalog as BeamlineCatalog;
        // this.catalogInfo = this.catalog?.pendingResource;
        // this.selectedBeamlineHistory.emit(this.catalog);
        let beamlineCatalog = historyItem?.beamlineCatalog;
        if (beamlineCatalog)
          this.catalog = beamlineCatalog;
        else {
          beamlineCatalog = (await this.getPendingCatalog(historyItem.id)).beamlineCatalogs?.at(-1) as BeamlineCatalog;
          historyItem.beamlineCatalog = beamlineCatalog;
        }
        this.catalog = beamlineCatalog as BeamlineCatalog;

        this.catalogInfo = (this.catalog as BeamlineCatalog).pendingResourceCatalog;
        this.selectedBeamlineHistory.emit(this.catalog);
        break;
    }
  }

  async getPendingCatalog(id: number) {
    return firstValueFrom(this._service.GetHistoryByID(this.type!, id));
  }


}
